module.exports = __webpack_public_path__ + "static/media/ersattning.bb0aa8ed.mp3";